import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import { Grid } from '@mui/material';
import PieUbicaciones from '../Componentes/Dashboard/ProductosxUbicacion/PieProductosxUbicacion';
import PieEstados from '../Componentes/Dashboard/ProductosxEstado/PieProductosxEstado';
import BarUbicaciones from '../Componentes/Dashboard/ProductosxUbicacion/BarUbicaciones';
import BarEnviosRecepciones from '../Componentes/Dashboard/ProductosxEnvios/BarEnviosRecepciones';

export default function Dashboard() {
  const [nombreUsuario, setNombreUsuario] = useState('');

  useEffect(() => {
    const obtenerNombreUsuarioSesion = () => {
      const nombreUsuarioSesion = localStorage.getItem('nombreUsuario');
      setNombreUsuario(nombreUsuarioSesion || 'Invitado');
    };
    obtenerNombreUsuarioSesion();
  }, []);

  return (
    <Container style={{ marginTop: 0, textAlign: 'center', paddingBottom: '50px' }}> {/* <-- Añade paddingBottom aquí */}
      <h1 className="my-4 text-center" style={{ fontWeight: 'bold', color: '#007bff' }}>Reportes de productos</h1>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <BarUbicaciones />
        </Grid>

        <Grid item xs={12} md={4}>
          <PieEstados />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <BarEnviosRecepciones />
        </Grid>
      </Grid>
    </Container>
  );
}
